import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { Dashboard } from './app/pages/dashboard/dashboard';
import { Documentation } from './app/pages/documentation/documentation';
import { Landing } from './app/pages/landing/landing';
import { Notfound } from './app/pages/notfound/notfound';

import { authGuard } from './app/auth/auth-guard';
import { roleGuard } from './app/auth/role.guard';

export const appRoutes: Routes = [
  // -------------------------
  // 🔒 Protected App (بعد از لاگین)
  // -------------------------
  {
    path: '',
    component: AppLayout,
    canActivate: [authGuard],
    children: [
      // داشبورد
      { path: '', component: Dashboard },

      // صفحات عمومی داخل اپ
      { path: 'documentation', component: Documentation },
      { path: 'pages', loadChildren: () => import('./app/pages/pages.routes') },

      // -------------------------
      // 🎫 Ticketing
      // -------------------------
      {
        path: 'ticketing/new',
        canActivate: [roleGuard(['admin', 'manager', 'expert', 'user', 'it', 'employee'])],
        loadComponent: () =>
          import('./app/project/ticketing/ticket-create.page').then((m) => m.TicketCreatePage),
      },
      {
        path: 'ticketing/my',
        canActivate: [roleGuard(['admin', 'manager', 'expert', 'user', 'employee', 'it'])],
        loadComponent: () =>
          import('./app/project/ticketing/ticket-list.page').then((m) => m.TicketListPage),
        data: { mode: 'my' },
      },
      {
        path: 'ticketing/queue',
        canActivate: [roleGuard(['admin', 'manager', 'expert', 'it'])],
        loadComponent: () =>
          import('./app/project/ticketing/ticket-list.page').then((m) => m.TicketListPage),
        data: { mode: 'queue' },
      },
      {
        path: 'ticketing/:id',
        canActivate: [roleGuard(['admin', 'manager', 'expert', 'user', 'employee', 'it'])],
        loadComponent: () =>
          import('./app/project/ticketing/ticket-view.page').then((m) => m.TicketViewPage),
      },
      {
        path: 'colleagues',
        canActivate: [roleGuard(['admin'])],
        loadComponent: () =>
          import('./app/project/colleagues/colleague-admin.page').then((m) => m.ColleagueAdminPage),
      },
      {
        path: 'colleague',
        canActivate: [roleGuard(['colleague'])],
        loadComponent: () =>
          import('./app/project/colleagues/colleague-trader.page').then((m) => m.ColleagueTraderPage),
      },

      // -------------------------
      // 👥 مدیریت کاربران (Admin only)
      // -------------------------
      {
        path: 'users',
        canActivate: [roleGuard(['admin'])],
        loadComponent: () =>
          import('./app/project/users/users.page').then((m) => m.UsersPage),
      },
      {
        path: 'roles',
        canActivate: [roleGuard(['admin'])],
        loadComponent: () =>
          import('./app/project/roles/roles.page').then((m) => m.RolesPage),
      },
      {
        path: 'departments',
        canActivate: [roleGuard(['admin'])],
        loadComponent: () =>
          import('./app/project/departments/departments.page').then((m) => m.DepartmentsPage),
      },

      // -------------------------
      // 📊 گزارش‌ها / لاگ‌ها (Admin only)
      // -------------------------
      {
        path: 'userLog',
        canActivate: [roleGuard(['admin'])],
        loadComponent: () =>
          import('./app/project/user-auth-logs/user-auth-logs').then((m) => m.UserAuthLogsComponent),
      },
      {
        path: 'attendanceAdmin',
        canActivate: [roleGuard(['admin'])],
        loadComponent: () =>
          import('./app/project/attendance-admin/attendance-admin').then((m) => m.AttendanceAdminComponent),
      },
    ],
  },

  // -------------------------
  // 🌍 Public Routes
  // -------------------------
  { path: 'landing', component: Landing },

  // ✅ لاگین داخلی Angular را کلاً بی‌اثر می‌کنیم
  { path: 'auth', children: [{ path: '**', redirectTo: '' }] },

  { path: 'notfound', component: Notfound },

  // -------------------------
  // ❌ Fallback
  // -------------------------
  { path: '**', redirectTo: '/notfound' },
];
